import { Component, ViewEncapsulation } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { HttpClient } from '@angular/common/http'
import { environment } from 'environments/environment'
import { AuthService } from '../../_services'
import { LoaderService } from '../../_services/loader.service'
import { process, State, aggregateBy } from '@progress/kendo-data-query'
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query'
import { Observable } from 'rxjs/Observable'
import {
  SelectableSettings,
  DataStateChangeEvent,
  GridDataResult,
  LogicalRowDirective,
} from '@progress/kendo-angular-grid'
import { ExcelExportData } from '@progress/kendo-angular-excel-export'
import * as _moment from 'moment'
import * as XLSX from 'xlsx'
import * as _rollupMoment from 'moment'
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast'
import { Console } from 'console'
const moment = _rollupMoment || _moment

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

declare var $: any
const distinctTSID = (data) =>
  data.filter((x, idx, xs) => xs.findIndex((y) => y.TSID === x.TSID) === idx)
const distinctZone = (data) =>
  data.filter((x, idx, xs) => xs.findIndex((y) => y.Zone === x.Zone) === idx)
const distinctSuplr = (data) =>
  data.filter(
    (x, idx, xs) => xs.findIndex((y) => y.Supplier === x.Supplier) === idx,
  )
const distinctVeh = (data) =>
  data.filter(
    (x, idx, xs) => xs.findIndex((y) => y.VehicleNo === x.VehicleNo) === idx,
  )

@Component({
  //selector: 'ts-manulFileUpload',
  templateUrl: './manualFileUpload.component.html',
  //encapsulation: ViewEncapsulation.None,
  // styleUrls: ['./plant.component.css']
})
export class manualFileUpload {
  prjId: any
  prjName: any
  showLoader: boolean
  startDate: any
  endDate: any
  defStartDt: any
  defEndDt: any
  dateRange: any
  plantReportList: any
  totalCount: any
  imageUrl: any
  entityName: any
  entityType: any
  qrCd: any
  serviceDate: any
  totalInWaight: any
  totalOutWaight: any
  totalNetWaight: any
  header: any
  swmReport: any
  inWaitInTonne: any
  outWaitInTonne: any
  netInTonne: any
  hideUlbColumn = false
  swmHeadingHide = false
  GFcolumnHide = false
  GlLKcolumnHide = false
  public aggregates: any[] = [
    { field: 'InWeight', aggregate: 'sum' },
    { field: 'OutWeight', aggregate: 'sum' },
    { field: 'NetWeight', aggregate: 'sum' },
  ]
  public state: State = {
    skip: 0,
    take: 12,
    filter: {
      logic: 'and',
      filters: [],
    },
  }
  public pageSize: any
  public checkboxOnly = false
  public mode = 'multiple'
  public selectableSettings: SelectableSettings

  public distinctFilter: any[]
  public distinctZone: any[]
  public distinctSuplr: any[]
  public distinctVeh: any[]

  public groups: GroupDescriptor[] = []
  public view: Observable<GridDataResult>
  public hiddenColumns: string[] = []
  nameWodal: any
  userCdModal: any
  mobileModal: any
  PasswordModal: any
  confPassModal: any
  EmailModal: any
  error: boolean
  success: boolean
  responceMessage: any
  LocationModal: { ID: string; LocationName: string }[]
  UsageModal: { ID: string; UsageName: string }[]
  LocationValue: any
  UsageValue: any
  UsageName: any
  WeighUserDeatsil: any
  file: boolean
  id: any
  data: any
  Mdata: any
  uploadButton: boolean
  dataUploadFor: string
  ProjectList: any

  public isHidden(columnName: string): boolean {
    return this.hiddenColumns.indexOf(columnName) > -1
  }

  public gridDataPlantReport: DataResult
  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups
    this.loadProducts()
  }
  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.plantReportList,
    }
    return result
  }

  private loadProducts(): void {
    this.gridDataPlantReport = process(this.plantReportList, {
      group: this.groups,
    })
  }
  constructor(
    private http: HttpClient,
    private auth: AuthService,
    public routes: ActivatedRoute,
    public router: Router,
    private loaderService: LoaderService,
  ) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val
    })
    this.allData = this.allData.bind(this)
    var date = new Date()
    this.defStartDt =
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    this.defEndDt =
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    this.dateRange = {
      beginDate: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      },
      endDate: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      },
    }

    this.ProjectList = [
      { id: 'GGN', name: 'GURUGRAM' },
      { id: 'FBD', name: 'FARIDABAD' },
      { id: 'LOK', name: 'LUCKNOW' },
    ]

    this.LocationModal = [
      {
        ID: '1',
        LocationName: 'Bandhwari',
      },
      {
        ID: '2',
        LocationName: 'Badshahpur',
      },
      {
        ID: '3',
        LocationName: 'MRF',
      },
    ]

    //  UsageModal

    this.UsageModal = [
      {
        ID: '1',
        UsageName: 'MRF',
      },
      {
        ID: '2',
        UsageName: 'Plant',
      },
      {
        ID: '3',
        UsageName: 'TS',
      },
    ]

    this.uploadButton = false
  }

  /*
   * get Mobility Service Report
   */

  getVehiclesDetail() {
    //  this.loaderService.display(true);
    //     this.http.get(environment.apiUrl + 'reports/getVehiclesDetail?prjid='+this.prjId).subscribe(data =>{
    //     console.log('131',data);
    // });
  }

  /*
   * filter The Date
   */
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state
    this.gridDataPlantReport = process(this.plantReportList, this.state)
    if (state && state.group) {
      state.group.map((group) => (group.aggregates = this.aggregates))
      //this.totalCount= this.gridDataPlantReport.data.length
      this.totalInWaight = aggregateBy(
        this.gridDataPlantReport.data,
        this.aggregates,
      )['InWeight'].sum
      //this.inWaitInTonne=Number(this.totalInWaight)/1000
      this.totalOutWaight = aggregateBy(
        this.gridDataPlantReport.data,
        this.aggregates,
      )['OutWeight'].sum
      //this.outWaitInTonne=Number(this.totalOutWaight)/1000
      this.totalNetWaight = aggregateBy(
        this.gridDataPlantReport.data,
        this.aggregates,
      )['NetWeight'].sum
      //this.netInTonne=Number(this.totalNetWaight)/1000
      this.gridDataPlantReport = process(this.plantReportList, this.state)
    }
  }

  /*
   *select start Date Nad To date
   */
  onDateRangeChanged(dataRange) {
    if (dataRange.beginDate.day > 0) {
      this.startDate =
        dataRange.beginDate.year +
        '-' +
        dataRange.beginDate.month +
        '-' +
        dataRange.beginDate.day
      this.endDate =
        dataRange.endDate.year +
        '-' +
        dataRange.endDate.month +
        '-' +
        dataRange.endDate.day
      this.getVehiclesDetail()
    } else if (dataRange.beginDate.day == 0) {
      this.startDate = this.defStartDt
      this.endDate = this.defEndDt
      this.getVehiclesDetail()
    }
  }

  /*
   *Select Export PDF header
   */

  ngOnInit() {
    // this.startDate = moment(this.defStartDt).format('YYYY-MM-DD');
    // this.endDate= moment(this.defEndDt).format('YYYY-MM-DD');
    this.prjId = this.auth.getAuthentication().projectId

    this.getWeighUserDeatsil()

    //this.testingOAReoports()

    // this.getVehiclesDetail();
  }

  // newWeighBridgeDetails   work starst

  newWeighBridgeDetails() {
    $('#newWeighBridgemadal').modal('show')
  }

  newUsersWeighBridgeDetails() {
    //  this.nameWodal  = "atul"

    this.success = false
    this.error = false
    ;(this.nameWodal = null),
      (this.mobileModal = null),
      (this.EmailModal = null),
      (this.PasswordModal = null),
      (this.userCdModal = null),
      $('#NewUserModal').modal('show')
  }

  onChangeLocationModal(e) {
    this.LocationValue = e.LocationName

    console.log(this.LocationValue)
  }

  onChangeUsageModal(e) {
    this.UsageValue = e.UsageName

    console.log(this.UsageValue)
  }

  saveUsersWeighBridgeDetails() {
    console.log('223', this.nameWodal)

    if (!this.nameWodal) {
      alert('User name is required!')
      return
    } else if (!this.userCdModal) {
      alert('User code is required!')
      return
    } else if (!this.mobileModal) {
      alert('Mobile is required!')
      return
    } else if (this.mobileModal.length != 10) {
      alert('Invalid Mobile No!')
      return
    } else if (!this.PasswordModal) {
      alert('Password is required!')
      return
    } else if (this.PasswordModal != this.confPassModal) {
      alert('Password does not match with confirm password!')
      return
    }
    var newStr = this.userCdModal.replace(/\s+/g, '')

    console.log('newStr', newStr)

    var newUsers = {
      USERCD: this.userCdModal,
      NAME: this.nameWodal,
      MOBNO: this.mobileModal,
      EMAIL: this.EmailModal,
      PASSWORD: this.PasswordModal,
      LOCATION: this.LocationValue,
      USAGE: this.UsageValue,
    }

    console.log('newUsers', newUsers)

    this.http
      .post(
        environment.apiUrl + 'WeighBridge/saveUsersWeighBridgeDetails',
        newUsers,
      )
      .subscribe((data) => {
        var code: any
        code = data

        console.log('ok', code['ok'])

        if (code['ok'] == 'ok') {
          this.error = false
          this.success = true

          setTimeout(() => {
            ;(this.nameWodal = null),
              (this.userCdModal = null),
              (this.mobileModal = null),
              (this.EmailModal = null),
              (this.PasswordModal = null)
            this.confPassModal = null
            this.success = false
            this.getWeighUserDeatsil()
            $('#NewUserModal').modal('hide')
          }, 2000)
        } else {
          this.error = true
          this.success = false
        }
      })
  }

  getWeighUserDeatsil() {
    console.log('402')

    this.loaderService.display(true)

    this.http
      .get(
        environment.apiUrl +
          'WeighBridge/getWeighUserDeatsil?prjid=' +
          this.prjId,
      )
      .subscribe((data) => {
        this.WeighUserDeatsil = data

        console.log('411', this.WeighUserDeatsil)
        this.loaderService.display(false)
      })
  }

  // manul upload code start

  insertExcell() {
    $('#uploadModal').modal('show')
  }

  onFileChange(evt: any) {
    const target: DataTransfer = <DataTransfer>evt.target

    if (target.files.length !== 1) throw new Error('Cannot use multiple files')

    const reader: FileReader = new FileReader()
    reader.onload = (e: any) => {
      const bstr: string = e.target.result
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' })

      const wsname: string = wb.SheetNames[0]

      const ws: XLSX.WorkSheet = wb.Sheets[wsname]

      this.data = XLSX.utils.sheet_to_json(ws, { header: 1 })
      let x = this.data.slice(1)

      console.log(472, this.data)
    }

    reader.readAsBinaryString(target.files[0])
  }

  saveExcellData() {
    let text = 'are you sure to upload right file to save data '
    if (confirm(text) == true) {
      text = 'You pressed OK!'
      var jasondata = this.data

      $('#fileInput').val('')

      var manualjasondata = []

      for (var i = 1; i < jasondata.length; i++) {
        console.log(
          'Date',
          moment(jasondata[1][2]).format('YYYY-MM-DD HH:mm:ss'),
          moment(jasondata[1][3]).format('YYYY-MM-DD HH:mm:ss'),
        )

        manualjasondata.push({
          // 'IMEI':jasondata[i][0],
          // 'R_DATE':jasondata[i][1]
          // 'ID':jasondata[i][35],
          // SRNO: jasondata[i][0],
          //'SlipNo':'WB1/'+moment(jasondata[i][11] +' '+ jasondata[i][12]).format('YYYYMMDDHHmmss'),
          //'SlipNo':jasondata[i][2],
          //'MaterialType':jasondata[i][3],
          //'MaterialCode':jasondata[i][4],
          //'MaterialName':jasondata[i][5],
          //'CityCode':jasondata[i][6],
          //'CityName':jasondata[i][7],
          //'SupplierCode':jasondata[i][8],
          //'SupplierName':jasondata[i][9],
          // 'PartyCode':jasondata[i][10],
          //'PartyName':jasondata[i][11],
          //'ZoneCode':jasondata[i][12],
          //'ZoneName':jasondata[i][13],
          InDate: moment(jasondata[i][2]).format('YYYY-MM-DD HH:mm:ss'),
          OutDate: moment(jasondata[i][3]).format('YYYY-MM-DD HH:mm:ss'),
          // 'OutDatecheck':moment(jasondata[i][15]).format('YYYY-MM-DD HH:mm:ss'),
          // 'VehNo1':jasondata[i][16],
          // 'VehNo2':jasondata[i][17],
          // 'VehNo3':jasondata[i][4],
          VehNo: jasondata[i][4],
          //'VehicleType':jasondata[i][20],
          //'DriverName':jasondata[i][21],
          // 'CompectorNo':"",
          //'TSID':jasondata[i][23],
          // 'Consignee':"",
          // 'Remark':jasondata[i][25],
          // 'WBNO':jasondata[i][26],
          // 'PlantName':jasondata[i][6],
          InWeight: jasondata[i][7],
          OutWeight: jasondata[i][8],
          NetWeight: jasondata[i][9],
          // 'ULBCode':'ULB4',
          // 'ULBName':'System.Data.DataRowView',
          //'Outward_Recordtype':jasondata[i][33],
        })

        //  if(this.dataUploadFor = 'GGN'){
        //     manualjasondata.push({
        //       // 'ID':jasondata[i][35],
        //       'SRNO':jasondata[i][1],
        //       //'SlipNo':'WB1/'+moment(jasondata[i][11] +' '+ jasondata[i][12]).format('YYYYMMDDHHmmss'),
        //       'SlipNo':jasondata[i][2],
        //       'MaterialType':jasondata[i][3],
        //       'MaterialCode':jasondata[i][4],
        //       'MaterialName':jasondata[i][5],
        //       'CityCode':jasondata[i][6],
        //       'CityName':jasondata[i][7],
        //       'SupplierCode':jasondata[i][8],
        //       'SupplierName':jasondata[i][9],
        //       'PartyCode':jasondata[i][10],
        //       'PartyName':jasondata[i][11],
        //       'ZoneCode':jasondata[i][12],
        //       'ZoneName':jasondata[i][13],
        //       'InDate':moment(jasondata[i][14]).format('YYYY-MM-DD HH:mm:ss') ,
        //       'OutDate':moment(jasondata[i][15]).format('YYYY-MM-DD HH:mm:ss'),
        //       'OutDatecheck':moment(jasondata[i][15]).format('YYYY-MM-DD HH:mm:ss'),
        //       // 'VehNo1':jasondata[i][16],
        //       // 'VehNo2':jasondata[i][17],
        //       // 'VehNo3':jasondata[i][18],
        //       'VehNo':jasondata[i][19],
        //       'VehicleType':jasondata[i][20],
        //       'DriverName':jasondata[i][21],
        //       // 'CompectorNo':"",
        //       'TSID':jasondata[i][23],
        //       // 'Consignee':"",
        //       'Remark':jasondata[i][25],
        //       'WBNO':jasondata[i][26],
        //       // 'PlantName':jasondata[i][6],
        //       'InWeight':jasondata[i][28],
        //       'OutWeight':jasondata[i][29],
        //       'NetWeight':jasondata[i][30],
        //       // 'ULBCode':'ULB4',
        //       // 'ULBName':'System.Data.DataRowView',
        //       'Outward_Recordtype':jasondata[i][33],

        //      })

        //   }

        //  if(this.dataUploadFor = 'FBD'){
        //     manualjasondata.push({
        //       // 'ID':jasondata[i][35],
        //       'SRNO':jasondata[i][1],
        //       //'SlipNo':'WB1/'+moment(jasondata[i][11] +' '+ jasondata[i][12]).format('YYYYMMDDHHmmss'),
        //       'SlipNo':jasondata[i][2],
        //       'MaterialType':jasondata[i][3],
        //       'MaterialCode':jasondata[i][4],
        //       'MaterialName':jasondata[i][5],
        //       'CityCode':jasondata[i][6],
        //       'CityName':jasondata[i][7],
        //       'SupplierCode':jasondata[i][8],
        //       'SupplierName':jasondata[i][9],
        //       'PartyCode':jasondata[i][10],
        //       'PartyName':jasondata[i][11],
        //       'ZoneCode':jasondata[i][12],
        //       'ZoneName':jasondata[i][13],
        //       'InDate':moment(jasondata[i][14]).format('YYYY-MM-DD HH:mm:ss') ,
        //       'OutDate':moment(jasondata[i][15]).format('YYYY-MM-DD HH:mm:ss'),
        //       'OutDatecheck':moment(jasondata[i][15]).format('YYYY-MM-DD HH:mm:ss'),
        //       // 'VehNo1':jasondata[i][16],
        //       // 'VehNo2':jasondata[i][17],
        //       // 'VehNo3':jasondata[i][18],
        //       'VehNo':jasondata[i][19],
        //       'VehicleType':jasondata[i][20],
        //       'DriverName':jasondata[i][21],
        //       // 'CompectorNo':"",
        //       'TSID':jasondata[i][23],
        //       // 'Consignee':"",
        //       'Remark':jasondata[i][25],
        //       'WBNO':jasondata[i][26],
        //       // 'PlantName':jasondata[i][6],
        //       'InWeight':jasondata[i][28],
        //       'OutWeight':jasondata[i][29],
        //       'NetWeight':jasondata[i][30],
        //       // 'ULBCode':'ULB4',
        //       // 'ULBName':'System.Data.DataRowView',
        //       'Outward_Recordtype':jasondata[i][33],

        //      })

        //   }
      }

      this.displaymanualData(manualjasondata)

      $('#uploadModal').modal('hide')
    } else {
      text = 'You canceled!'
    }

    this.file = false
  }

  displaymanualData(manualjasondata) {
    this.uploadButton = true
    this.Mdata = manualjasondata
  }

  async saveManualWeighbridgeDaata() {
    console.log('613 today', this.Mdata)

    var array = this.Mdata

    const chunkSize = 200
    for (let i = 0; i < array.length; i += chunkSize) {
      const chunkArray = array.slice(i, i + chunkSize)

      await this._uploadEntries(chunkArray)
    }
  }

  async _uploadEntries(data) {
    var wbData = {
      data: data,
    }

    console.log('wbData', wbData)
    return new Promise(async (resolve, reject) => {
      await this.http
        .post(
          environment.apiUrl + 'reports/insertManualWeighbridgeEnrty',
          wbData,
        )
        .toPromise()
        .then((value) => {
          console.log('value returned', value)

          resolve(true)
        })
    })
  }

  // testingOAReoports() {
  //   let dataPost = { tableId: '' }

  //   this.http
  //     .post(
  //       'http://111.0.69.108:2021/seekdi_form/formController/getAll',
  //       dataPost,
  //     )
  //     .subscribe((response) => {
  //       console.log(response)
  //     })
  // }
}



// WEBPACK FOOTER //
// ./src/app/reports/plant/manualFileUpload.component.ts